import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { QuestOrderCode } from '../../models/quest-order-code';
import { getQuestOrderCodes } from '../../apis/emr-data';

export interface State {
    allIds: string[];   // id: testCD
    byId: Dictionary<QuestOrderCode>;
    loading: Dictionary<boolean>;
}

export const questOrderCodes = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: QuestOrderCode[],
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                const byId = {
                    ...state.byId,
                    ...storeByTestCD(data)
                };
                return {
                    ...state,
                    allIds: Object.keys(byId),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getQuestOrderCodesAsync(
            ids: Undefinable<string>[],
            rootState: RootState
        ) {
            const notExistedIds = selectors.getOtherQuestOrderCodeIds(rootState.questOrderCodes, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getQuestOrderCodes(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});

const storeByTestCD = (data: Undefinable<MixType<QuestOrderCode>>): Dictionary<QuestOrderCode> => {
    if (data) {
        if (Array.isArray(data)) {
            return data.reduce(
                (prev, x) => {
                    if (x.testCD) {
                        prev[x.testCD] = x;
                    }
                    return prev;
                },
                {} as Dictionary<QuestOrderCode>
            );
        } else {
            if (data.testCD) {
                return {
                    [data.testCD]: data
                } as Dictionary<QuestOrderCode>;
            }
        }
    }
    return {} as Dictionary<QuestOrderCode>;
};
